export default (url: string | undefined): string => {
    if (!url) {
        return "";
    }

    url = url
        .toString()
        .replace(new RegExp("http://localhost:3000", "g"), "")
        .replace(new RegExp("https://stage.easyfood.frontend.heyday.dk", "g"), "")
        .replace(new RegExp("http://easyfood.heyday.dk", "g"), "")
        .replace(new RegExp("https://easyfood.dk", "g"), "");
    return url.toString();
};
